import { useCallback, useState } from "react";
import { getSettingsPageParent } from "../utils/settingsHelpers";

export function useSettingsState() {
  const [showProfilePhotoActions, setShowProfilePhotoActions] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [isClosingSettingsModal, setIsClosingSettingsModal] = useState(false);
  const [settingsPage, setSettingsPage] = useState("home");
  const [settingsPageDirection, setSettingsPageDirection] = useState("forward");

  const [isEditingAccount, setIsEditingAccount] = useState(false);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editNameWarning, setEditNameWarning] = useState("");

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState("");
  const [showClearDataConfirm, setShowClearDataConfirm] = useState(false);

  const [supportMessages, setSupportMessages] = useState([]);
  const [supportInput, setSupportInput] = useState("");
  const [supportIsTyping, setSupportIsTyping] = useState(false);
  const [supportError, setSupportError] = useState("");
  const [expandedFaqs, setExpandedFaqs] = useState([]);

  const closeSettingsModal = useCallback(() => {
    setIsClosingSettingsModal(true);

    setTimeout(() => {
      setShowSettingsModal(false);
      setIsClosingSettingsModal(false);
      setSettingsPage("home");
      setSettingsPageDirection("forward");
    }, 220);
  }, [
    setIsClosingSettingsModal,
    setShowSettingsModal,
    setSettingsPage,
    setSettingsPageDirection
  ]);

  function openSettingsPage(page) {
    setSettingsPageDirection("forward");
    setSettingsPage(page);
  }

function goBackSettingsPage() {
    setSettingsPageDirection("backward");
    setSettingsPage(getSettingsPageParent(settingsPage));
  }

  function toggleProfilePhotoActions() {
    setShowProfilePhotoActions((prev) => !prev);
  }

  return {
    showProfilePhotoActions,
    setShowProfilePhotoActions,
    showSettingsModal,
    setShowSettingsModal,
    isClosingSettingsModal,
    setIsClosingSettingsModal,
    settingsPage,
    setSettingsPage,
    settingsPageDirection,
    setSettingsPageDirection,

    isEditingAccount,
    setIsEditingAccount,
    editName,
    setEditName,
    editEmail,
    setEditEmail,
    editNameWarning,
    setEditNameWarning,

    showDeleteConfirm,
    setShowDeleteConfirm,
    deleteConfirmText,
    setDeleteConfirmText,
    showClearDataConfirm,
    setShowClearDataConfirm,

    supportMessages,
    setSupportMessages,
    supportInput,
    setSupportInput,
    supportIsTyping,
    setSupportIsTyping,
    supportError,
    setSupportError,
    expandedFaqs,
    setExpandedFaqs,

    closeSettingsModal,
    openSettingsPage,
    goBackSettingsPage,
    toggleProfilePhotoActions
  };
}